import {
    serverBus
} from '@/main'
import {
    CPUtils
} from '@/scripts/Utils'
import Global from '@/scripts/Global'
import MessageArea from '@/components/MessageArea/MessageArea.vue'
import Message from '@/components/Message/Message.vue'
import JoinMessage from '@/components/JoinMessage'
import MissedCallMessage from '@/components/MissedCallMessage'
import LeaveMessage from '@/components/LeaveMessage'
import DeleteUserMessage from '@/components/DeleteUserMessage'
import ChannelInfo from '@/components/ChannelInfo/ChannelInfo.vue'
import CallerPeer from '@/components/CallerPeer'
import CalleePeer from '@/components/CalleePeer'
import RTCCallBanner from '@/components/RTCCallBanner'

import ChannelApi from '@/scripts/api/channel.api'
import SessionManager from '@/Manager/Session.manager'
import MessageHandler from '@/Handler/MessageHandler'

import {
    Search
} from '@/classes/Search'
import DOMManager from '@/Manager/DOM.manager';
import KeyboardManager from '@/Manager/keyboard.manager';
import VueSignals from '@/scripts/VueSignals';
import MainNotification from '@/Manager/Notification/main.manager';

import DragAndDropMention from '@/scripts/mixins/DragAndDropMention.js';

import Socket from '@/classes/WebSocket.js';


let messageScroll = true
let isAutoScroll = true

let hasUnreadMessages = false
let sqn = 0
let postCallDirection = "up"
let highlight_post_id = ''
// let highlight_post_sqn = ''

let curScrollPos = 0
let oldScroll = 0

export default {
    name: 'chat',
    props: ['search_result'],
    data() {
        return {
            withNeedsPermissionClass: false,
            message: null,
            loading: false,
            mainSpinner: true,
            activeChannelDoc: SessionManager.getActiveChannel(),
            loggedInUserDoc: SessionManager.getLoggedInUser(),
            yesterday: new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString("en-DE"),
            today: new Date().toLocaleDateString("en-DE"),
            messageQueue: [],
            messageDatesQueue: [],
            checkCountNotViewed: false,
            countNotViewed: 0,
            nomoreUp: false,
            nomoreDown: false,
            ChannelUsersObjects: SessionManager.getActiveChannelUsers(),
            isAdmin: false,
            isSearch: false,
            dropFile: false,
            newMessageNav: false,
            HasEnoughMessages: false,
            MessageToEdit: '',
            showSeenBy: '',
            postToEditId: '',
            connectionLost: false,
            tryToSendMessage: false,
            needsPermission: false,
            notificationAllowed: true,
            reconnectAttempt: 0,
            isChrome: !!window.chrome && !!window.chrome.webstore,
            showConference: true,
        }
    },
    components: {
        MessageArea,
        Message,
        JoinMessage,
        LeaveMessage,
        DeleteUserMessage,
        ChannelInfo,
        CallerPeer,
        CalleePeer,
        MissedCallMessage,
        RTCCallBanner,
    },
    mixins: [DragAndDropMention],
    updated: function() {
        /** make 'Splash screen' off messages has been arrived */
        this.$nextTick(function() {
            // Code that will run only after the
            // entire view has been re-rendered
            let container = document.querySelector("#chat_queue")
            if (container != null && !this.isSearch) {
                let newScroll = container.scrollHeight - container.clientHeight;
                container.scrollTop = curScrollPos + (newScroll - oldScroll)
            }
        })
    },
    created() {
        /************ realated to get data from search overlay ************/
        if (typeof this.search_result != 'undefined') {
            this.messageQueue = []
            this.messageDatesQueue = []
            this.loading = true
            this.ChannelUsersObjects = SessionManager.getActiveChannelUsers()
            let oSearch = new Search()
            this.search_result.forEach(function(currPost) {
                oSearch.addPost(currPost)
            })
            this.isSearch = true
            this.messageQueue = oSearch.getPosts() // @Warning search
            this.messageDatesQueue = oSearch.getPostsDates()
            SessionManager.setActiveSearch(oSearch)
            this.mainSpinner = false
            this.loading = false
        }
    },
    mounted() {
        // Focus window to display caret in osx electron
        window.focus();
        /* get logged in user data */
        serverBus.$on(VueSignals.LOGGED_IN_USER, (success) => {
            this.loggedInUserDoc = SessionManager.getLoggedInUser()
            this.yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString(this.loggedInUserDoc.chat_visuals.language)
            this.today = new Date().toLocaleDateString(this.loggedInUserDoc.chat_visuals.language)
        })

        serverBus.$on("loading", (status) => {
            this.loading = status
        })

        serverBus.$on("close_search", (status) => {
            this.isSearch = false
        })


        /* message has been edited*/
        serverBus.$on(VueSignals.MESSAGE_CHANGED, (view) => {
            this.messageDatesQueue = SessionManager.GetPostDates()
            this.messageQueue = SessionManager.GetPosts()
        })

        /**Step 1 : get Channel details : ex: first_unread_post_sqn, user_admin */
        serverBus.$on(VueSignals.CHANNEL_DETAILS_OVERRIDED, (ch_id) => {
            if (this.activeChannelDoc.type != 'invitation') {
                SessionManager.ClearPosts()
                this.messageDatesQueue = []
                this.messageQueue = []
                if (!this.isSearch && highlight_post_id.length == 0) {
                    postCallDirection = "up"
                    if (!this.mainSpinner)
                        this.loading = true
                    this.activeChannelDoc = SessionManager.getActiveChannel()
                    sqn = SessionManager.getActiveChannel().sqn
                    // if(SessionManager.getActiveChannel().first_unread_post_sqn < SessionManager.getActiveChannel().sqn){
                    //   sqn = SessionManager.getActiveChannel().first_unread_post_sqn
                    //   if(SessionManager.getActiveChannel().sqn - SessionManager.getActiveChannel().first_unread_post_sqn > 20){
                    //     postCallDirection = "down"
                    //     messageScroll = false
                    //   }
                    // }
                    /**Step 2 : get Users in this channel to display for every post*/
                    SessionManager.PostsCall(sqn, postCallDirection).then(
                        res => {
                            if (res.data.result && res.data.posts.length > 0) {
                                if (!this.mainSpinner)
                                    this.loading = true
                                if (postCallDirection == "up") {
                                    res.data.posts = res.data.posts.reverse()
                                }
                                for (let i = 0; i < res.data.posts.length; i++) {
                                    if (typeof res.data.posts[i].not_viewed_user_ids != 'undefined' &&
                                        res.data.posts[i].not_viewed_user_ids.length > 0 &&
                                        res.data.posts[i].not_viewed_user_ids.indexOf(this.loggedInUserDoc.user_id) > -1) {
                                        hasUnreadMessages = true
                                    }
                                    SessionManager.AddPost(res.data.posts[i])
                                }
                                this.messageQueue = SessionManager.GetPosts()
                                this.messageDatesQueue = SessionManager.GetPostDates()
                                if (this.messageQueue.length > 20) {
                                    this.HasEnoughMessages = true
                                }
                                this.checkCountNotViewed = false
                            }
                            this.countNotViewed = res.data.countNotViewed
                            this.CalculateSQN()
                            if (SessionManager.getActiveChannel().sqn < 20 || this.messageQueue.length < 20) {
                                this.nomoreUp = true
                            }
                        }
                    ).then(res => {
                        Global.Splash(0)
                        this.mainSpinner = false
                    }).then(res => {
                        /** mark read for current view messages */
                        if (isAutoScroll && !this.loading && document.querySelector("#chat_queue") != null) {
                            this.CalculateMarkedView(document.querySelector("#chat_queue"))
                        }
                        this.loading = false
                        this.mainSpinner = false
                        CPUtils.ScrollChatMessagesToEnd()
                        Global.Splash(0)
                        /** add padding  for */
                        if (document.querySelector("#chat_queue") != null) {
                            document.querySelector("#chat_queue").addEventListener('scroll', this.HandleScroll)
                        }
                    }).catch(err => {
                        this.loading = false
                        this.mainSpinner = false
                        console.warn("err ===> " + err)
                    })
                }
            }
            Global.Splash(0)
            this.mainSpinner = false
        })



        /** Normal Chat behavior */
        if (!this.isSearch) {
            serverBus.$on(VueSignals.CHAT_SPINNER_OFF, (success) => {
                this.mainSpinner = false
            })

            serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (success) => {
                SessionManager.ClearPosts()
                this.activeChannelDoc = SessionManager.getActiveChannel()
                this.messageQueue = []
                this.messageDatesQueue = []
                this.getChannelDetails()
                hasUnreadMessages = false
                this.dropFile = false
                messageScroll = true
                isAutoScroll = true
                sqn = this.activeChannelDoc.sqn
                postCallDirection = "up"
                this.countNotViewed = 0
                highlight_post_id = ''
                // highlight_post_sqn= ''
            })

            serverBus.$on(VueSignals.EVENT_USER_CHANGED, (user_id) => {
                this.ChannelUsersObjects = SessionManager.getActiveChannelUsers()
            })

            serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL_NAME, (success) => {
                this.activeChannelDoc = SessionManager.getActiveChannel();
            })

            serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (success) => {
                SessionManager.ClearPosts()
                this.messageQueue = []
                this.messageDatesQueue = []
                this.activeChannelDoc = SessionManager.getActiveChannel()
                this.isSearch = false
                this.loading = false
                this.dropFile = false
                this.mainSpinner = true
                hasUnreadMessages = false
                messageScroll = true
                isAutoScroll = true
                sqn = this.activeChannelDoc.sqn
                highlight_post_id = ''
                // highlight_post_sqn = ''
                postCallDirection = "up"
                this.nomoreDown = false
                this.nomoreUp = false
                this.countNotViewed = 0
                if (this.activeChannelDoc.flag != 'Deleted') {
                    this.getChannelDetails()
                }
                /********************Get ChannelUsers ****************/
                this.ChannelUsersObjects = SessionManager.getActiveChannelUsers()
                // if(SessionManager.getActiveChannel().type == 'invitation' || SessionManager.getActiveChannel().flag.length > 0){
                //   this.mainSpinner = false
                // }

                // Scroll down
                // TODO: this scroll down will be in the way when in the future is implemented the last message seen by the user.
                document.querySelector("#chat_queue").scrollTop = document.querySelector("#chat_queue").scrollHeight;
            })

            /********************Remove user from not seen ****************/
            serverBus.$on(VueSignals.SOCKET_POST_SEEN, (postMessage) => {
                if (postMessage.event == VueSignals.SOCKET_POST_SEEN) {
                    let user_id = postMessage.user_id
                    if (typeof postMessage.channel_id != 'undefined') {
                        this.messageQueue.forEach(currPost => {
                            currPost.not_viewed_user_ids.splice(currPost.not_viewed_user_ids.indexOf(user_id), 1)
                        })
                    }
                    if (typeof postMessage.data != 'undefined') {
                        for (let i = 0; i < this.messageQueue.length; i++) {
                            if (postMessage.data.indexOf(this.messageQueue[i].post_id) > -1) {
                                this.messageQueue[i].not_viewed_user_ids.splice(this.messageQueue[i].not_viewed_user_ids.indexOf(user_id), 1)
                            }
                        }
                    }

                    // If not active, calculate notifications
                    // Case only triggered when have multiple chats open
                    // z.B browser and electron
                    if (!CPUtils.isTabActive() || !document.hasFocus()) {
                        SessionManager.updateChannelsUnreadMessages();
                    }
                }
            })



            /********************New Incoming message sent ****************/
            serverBus.$on(VueSignals.SOCKET_MESSAGE_POSTED, (chatMessage) => {
                var message_body = chatMessage.data

                if (chatMessage.event == VueSignals.SOCKET_MESSAGE_POSTED &&
                    typeof message_body != "undefined") {

                    let sender = SessionManager.getUser(message_body.user_id)

                    /** Not active channel || browser tab not active*/
                    if (SessionManager.getActiveChannel().channel_id != message_body.channel_id ||
                        (!CPUtils.isTabActive() || !document.hasFocus()) ||  // rethink this conditional. When first load tab active but browser minimized the isTabActive returns true
                        ( Global.isELectron() && !document.hasFocus() )) {

                        // Direct channel, sent by a different user than self
                        if (message_body.direct && sender.user_id != SessionManager.getLoggedInUserId()) {
                            this.sendMessageNotification(sender, message_body);
                        }

                        // Regular channel, sent by a different user than self, where self was mentioned
                        if (!message_body.direct && sender.user_id != SessionManager.getLoggedInUserId()
                            && message_body.mentioned_users && message_body.mentioned_users.includes(SessionManager.getLoggedInUserId())) {
                            this.sendMessageNotification(sender, message_body);
                        }
                    }
                }

                /** not direct channel notification */
                if (chatMessage.event == VueSignals.SOCKET_MESSAGE_POSTED &&
                    typeof message_body != "undefined" &&
                    SessionManager.getActiveChannel().channel_id == message_body.channel_id) {
                    SessionManager.AddPost(message_body)
                    if (document.querySelector("#chat_queue .unviewed-message") != null) {
                        isAutoScroll = true // Enable scroll
                    }
                    if (!isAutoScroll) {
                        this.newMessageNav = true
                    }
                    if (message_body.user_id != SessionManager.getLoggedInUserId()) {
                        this.countNotViewed++
                    }
                }
                CPUtils.ScrollChatMessagesToEnd()
                if (CPUtils.isTabActive() && document.hasFocus()) {
                    this.CalculateMarkedView(document.querySelector("#chat_queue"))
                }

                this.messageDatesQueue = SessionManager.GetPostDates()
                this.messageQueue = SessionManager.GetPosts()
                MessageHandler.MentionNotification(message_body)
            })

            /********************Deleted Message Notify****************/
            serverBus.$on(VueSignals.SOCKET_POST_DELETED, (data) => {
                if (data.event == VueSignals.SOCKET_POST_DELETED &&
                    data.channel_id == SessionManager.getActiveChannelId()) {
                    if (data.origin.user_id != this.loggedInUserDoc.user_id) {
                        this.messageQueue.find(currElem => {
                            if (typeof currElem != 'undefined' && currElem.post_id == data.post_id) {
                                let index = this.messageQueue.indexOf(currElem);
                                this.messageQueue.splice(index, 1)
                            }
                        })
                    }
                }
                Global.globalValue(VueSignals.MESSAGE_CHANGED, true)
            })

            /********************Edit Message Notify****************/
            serverBus.$on(VueSignals.SOCKET_POST_EDITED, (data) => {
                if (data.event == VueSignals.SOCKET_POST_EDITED &&
                    data.channel_id == SessionManager.getActiveChannelId()) {
                    for (let i = 0; i < this.messageQueue.length; i++) {
                        if (this.messageQueue[i].post_id == data.post_id) {
                            this.messageQueue[i].origin_parsed = data.post.origin_parsed
                            this.messageQueue[i].origin = data.post.origin
                            this.messageQueue[i].parsed_items = data.post.parsed_items
                            this.messageQueue[i].edited_at = data.post.edited_at
                            this.messageQueue = SessionManager.GetPosts()
                            break
                        }
                    }
                }
            })
            /**
             * Styling matter /** Permission Flag class */

            serverBus.$on(VueSignals.NOTIFICATION_NEED_PERMISSION, (data) => {
                this.withNeedsPermissionClass = data
            })
            Global.SplashTimeout(this.messageQueue.length)

        }

        serverBus.$on(VueSignals.REMOVE_POST_EDIT, (data) => {
            this.postToEditId = null
        })

        serverBus.$on(VueSignals.SEND_OFFLINE_MESSAGE, (status) => {
            this.tryToSendMessage = true
        })

        serverBus.$on(VueSignals.DELETE_MESSAGE, (message_id) => {
            this.deleteMessage(message_id);
        })

        serverBus.$on(VueSignals.CONNECTION_LOST, (status) => {
            if (status) {
                // Attempts are made each 5s /classes/WebSocket.js
                if (this.reconnectAttempt > 0) {
                    this.connectionLost = true;
                }
            } else {
                this.connectionLost = false;
                // Have to reload the component, usually this is called after
                // a network reconnection
                this.getChannelDetails();
                Global.globalValue(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL_NAME, true);
            }
        })

        serverBus.$on(VueSignals.NOTIFICATION_NEED_PERMISSION, (data) => {
            this.needsPermission = data
        })

        serverBus.$on(VueSignals.NOTIFICATION_ALLOWED, (data) => {
            this.notificationAllowed = data
        })

        serverBus.$on(VueSignals.RECONNECT_ATTEMPTS, (value) => {
            // Attempts are made each 5s /classes/WebSocket.js
            this.reconnectAttempt += 1;
        })

        // serverBus.$on("STREAM_VIDEO_TRACK", (track) => {

        //   this.videoTracks.push(track)
        //   console.log(track)
        // })



    },
    methods: {
        enableNotification() {
            MainNotification.init();
            // Ask for notifications from the chat domain
            this.popUpNotificationRequest();
        },
        popUpNotificationRequest() {
            let w = 425;
            let h = 200;
            let left = Math.abs((screen.width / 2) - (w / 2));
            let top = Math.abs((screen.height / 4) - (h / 2));
            window.open(`${Global.GetChatURL()}notificationrequest`, '', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
        },
        closePermission() {
            this.needsPermission = false
            this.connectionLost = false
            Global.globalValue(VueSignals.NOTIFICATION_NEED_PERMISSION, false)
        },
        showAllowNotification() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'denied_notification')
        },
        sendMessageNotification(sender, message_body) {
            let message = message_body.hasOwnProperty('origin') ? message_body.origin : origin_parsed;
            const notification_text = message.length <= 62 ? message : `${message.substring(0, 62)}...`;
            const notification_title = sender.username.length <= 27 ? sender.username : `${sender.username.substring(0, 27)}...`;
            MainNotification.push(notification_title, notification_text, message_body.channel_id);
        },
        HandleScroll(event) {
            /** Removing padding  */
            if (document.querySelector("#chat_queue").scrollHeight - document.querySelector("#chat_queue").clientHeight > 100) {
                document.querySelectorAll(".message_queue").forEach(currQueue => {
                    currQueue.style.paddingTop = "0rem"
                })
            }


            isAutoScroll = false
            let container = event.target
            curScrollPos = container.scrollTop
            oldScroll = container.scrollHeight - container.clientHeight


            /////////////////////////// activate Observer to always scroll after message
            if ((container.scrollHeight - container.clientHeight - container.scrollTop) <= 50) {
                this.newMessageNav = false
                isAutoScroll = true // Enable scroll
            }

            /////////////////////////// end of activate Observer to always scroll after message
            if (container.scrollTop < 200 &&
                highlight_post_id.length == 0 &&
                messageScroll &&
                !this.nomoreUp &&
                !this.loading &&
                !this.isSearch) {
                messageScroll = false
                this.loading = true
                postCallDirection = "up"


                SessionManager.PostsCall(sqn, postCallDirection).then(
                    res => {
                        if (res.data.result && res.data.posts.length > 0) {
                            res.data.posts = res.data.posts.reverse()
                            if (typeof res.data.posts != "undefined" && res.data.posts.length > 0) {
                                for (let i = 0; i < res.data.posts.length; i++) {
                                    SessionManager.AddPost(res.data.posts[i])
                                }
                                if (this.messageQueue.length > 20)
                                    this.HasEnoughMessages = true

                                this.CalculateSQN()
                                this.CalculateMarkedView(container)
                            }
                            messageScroll = true
                            this.countNotViewed = res.data.countNotViewed
                            this.loading = false
                            if (res.data.posts.length < 20) { //&& sqn != 0
                                this.nomoreUp = true
                                messageScroll = false
                            }
                        } else {
                            this.loading = false
                        }
                    })
            }
            if (highlight_post_id.length != 0) {
                highlight_post_id = ""
            }
            /** mark read for current view messages */
            // If tab is active and browser is focused
            if (CPUtils.isTabActive() && document.hasFocus()) {
                this.CalculateMarkedView(container)
            }
        },
        getInvitationCreator() {
            return SessionManager.getUser(this.activeChannelDoc.publish_user_cp_id)
        },
        getUserData(user_id) {
            if (user_id != SessionManager.getLoggedInUserId()) {
                let user = SessionManager.getUser(user_id)
                if (typeof user == 'undefined') {
                    return
                }

                if (this.activeChannelDoc.removed_users.indexOf(user.user_id) > -1) {
                    user.removed = true
                } else {
                    user.removed = false
                }
                return user
            } else if (user_id == SessionManager.getLoggedInUserId()) {
                return SessionManager.getLoggedInUser()
            }
        },
        getTime(timestamp) {
            let date;
            if (timestamp != null) {
                date = new Date(timestamp * 1000);
            } else {
                date = new Date();
            }
            let hours = date.getHours();
            let minutes = date.getMinutes();
            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            return hours + ":" + minutes;
        },
        getTimeTitle(timestamp) {
            return new Date(timestamp * 1000).toLocaleDateString("en", {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        markAllRead() {
            SessionManager.MarkAllPostsRead().then(res => {
                if (res.data.result) {
                    Global.globalValue(VueSignals.REMOVE_ALL_MENTIONS, SessionManager.getActiveChannel().channel_id);
                    this.countNotViewed = 0
                    SessionManager.SetReadStatus(false)
                    document.querySelectorAll('.unread').outerHTML = ""
                }
            });
        },
        displayDeleteMessageModal(message_id) {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'delete_message');
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "message_id": message_id,
            })
        },
        deleteMessage(message_id) {
            SessionManager.DeletePost(message_id)
            for (let i = 0; i < this.messageDatesQueue.length; i++) {
                let filteredDates = this.messageQueue.filter(currMessage => {
                    return currMessage.post_date == this.messageDatesQueue[i]
                })
                if (filteredDates.length <= 1) {
                    if (filteredDates.length == 0 || (filteredDates.length == 1 && filteredDates[0].post_id == message_id)) {
                        this.messageDatesQueue = this.messageDatesQueue.splice(i, 1)
                        break
                    }
                }
            }
        },
        editMessage(message) {
            Global.globalValue(VueSignals.SET_UP_EDIT_MESSAGE, message);
        },
        getChannelDetails() {
            let channel_id = SessionManager.getActiveChannel().channel_id
            if (typeof channel_id != "undefined" && channel_id.length > 0) {
                ChannelApi.channelDetails(channel_id).then(res => {
                    if (res && res.data.result) {
                        SessionManager.OverrideActiveChannel(res.data.channel, res.data.first_unread_post_sqn)
                        this.isAdmin = res.data.channel.admin
                    } else {

                        if (res.data.reason == "folder_not_found") {
                            this.activeChannelDoc.deleted = true
                        }
                        if (res.data.reason == "channel_id_invalid") {
                            this.mainSpinner = false
                            if (Global.GetStaticChannelIds().indexOf(SessionManager.getActiveChannel().channel_id) < 0) {
                                SessionManager.setFirstChannelActive()
                            }
                            return
                        }
                        Global.globalValue(VueSignals.CHANNEL_DETAILS_OVERRIDED, true)
                    }
                }, error => {
                    console.error('channelDetails', error);
                });
            }
        },
        acceptInvitation() {
            this.mainSpinner = true
            ChannelApi.acceptInvit(this.activeChannelDoc).then(res => {
                if (res.data.result) {
                    SessionManager.acceptInvitation(res.data.channel)
                } else {
                    SessionManager.removeChannel(SessionManager.getActiveChannelId())
                }
            })
        },
        declineInvitation() {
            this.mainSpinner = true
            ChannelApi.declineInvit(SessionManager.getActiveChannel()).then(res => {
                if (res.data.result) {
                    SessionManager.declineInvitation(SessionManager.getActiveChannel().channel_id, SessionManager.getActiveChannel().user_ids)
                } else {
                    SessionManager.removeChannel(SessionManager.getActiveChannelId())
                }
                this.mainSpinner = false
            })

        },
        CreateChannel() {
            this.mainSpinner = true;
            ChannelApi.createChannel(this.activeChannelDoc.channel_id, '').then(
                res => {
                    if (typeof res.data != 'undefined' && res.data.result) {
                        this.mainSpinner = false;
                        this.showModal = false;
                        try {
                            let new_channel = SessionManager.createChannel(res.data.channel)
                            SessionManager.setActiveChannel(new_channel)

                        } catch (e) {
                            console.log(e)
                        }
                    }
                }
            )
        },
        InviteUser() {
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'invite_user')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
        },
        editPurpose() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'purpose_edit')
        },
        createStorage() {
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'choose_folder')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
        },
        dragEnter(e) {
            if (e.dataTransfer.types.indexOf("Files") > -1) {
                this.dropFile = true
                e.preventDefault()
            }
        },
        dragEnd() {
            this.dropFile = false;
            document.getElementById('message_input').style.border = '';
        },
        DropFile(e) {
            e.preventDefault()
            this.dragEnd();
            Global.globalValue(VueSignals.UPLOAD_FILE, e.dataTransfer.files)
        },
        showUser(currentMessage, previousMessage) {
            if (typeof previousMessage == 'undefined') {
                return true
            }
            let timeCurrent = this.getTime(currentMessage.created_at)
            let timePrevious = this.getTime(previousMessage.created_at)

            if (currentMessage.user_id == previousMessage.user_id &&
                timeCurrent == timePrevious) {
                return false
            }

            return true
        },
        EnableScroll() {
            this.newMessageNav = false
            CPUtils.ScrollChatMessagesToEnd()
            isAutoScroll = true // Enable scroll
        },
        isUnread(not_viewed_user_ids) {
            if (not_viewed_user_ids.indexOf(this.loggedInUserDoc.user_id) > -1) {
                return 1
            }
            return 0
        },
        CalculateSQN() {
            if (postCallDirection == "up" && this.messageQueue.length > 0) {
                if (this.messageQueue[0].sqn > 0) {
                    sqn -= 20
                } else {
                    this.nomoreUp = true
                }
            }
        },
        CalculateMarkedView(container) {
            let msgs = document.querySelectorAll(".message_block")
            let curretViewedMessagesHeight = 0
            let TotalMessages = []
            let curretViewedMessages = []
            let notification_area = 0
            if (container != null) {
                let total = container.scrollHeight - container.clientHeight - container.scrollTop
                if (document.querySelector('.notification-block') != null) {
                    notification_area = 40
                }
                for (let i = msgs.length - 1; i >= 0; i--) {
                    curretViewedMessagesHeight += msgs[i].clientHeight
                    TotalMessages.push({
                        "id": msgs[i].id,
                        "user_id": msgs[i].dataset.user,
                        "unread": msgs[i].dataset.unread,
                        "sqn": msgs[i].dataset.sqn,
                        "y": curretViewedMessagesHeight
                    })
                }

                for (let i = TotalMessages.length - 1; i >= 0; i--) {
                    if (TotalMessages[i].y > total &&
                        TotalMessages[i].y < container.scrollHeight - container.scrollTop + notification_area &&
                        TotalMessages[i].unread == 1 &&
                        TotalMessages[i].user_id != this.loggedInUserDoc.user_id &&
                        curretViewedMessages.indexOf(TotalMessages[i].id) < 0) {
                        curretViewedMessages.push(TotalMessages[i].id.replace("post_", ""))
                        document.getElementById(TotalMessages[i].id).dataset.unread = 0
                    }
                }

                if (curretViewedMessages.length > 0) {
                    SessionManager.MarkPostsRead(curretViewedMessages).then(res => {
                        if (res.data.result) {
                            this.countNotViewed -= curretViewedMessages.length
                            Global.globalValue(VueSignals.READ_MESSAGE_IDS, curretViewedMessages)
                        }
                    })
                }

                if (this.countNotViewed == 0 && !this.checkCountNotViewed) {
                    this.checkCountNotViewed = true
                    SessionManager.SetReadStatus(false)
                    Global.globalValue(VueSignals.REMOVE_ALL_MENTIONS, SessionManager.getActiveChannel().channel_id);
                    Global.globalValue(VueSignals.ALL_MESSAGES_SEEN, SessionManager.getActiveChannelId())
                    Global.setFaviconNormal()
                }
            }
        },
        ShowUserDetails(user_id) {
            Global.globalValue(VueSignals.SHOW_USER_DETAILS, user_id)
        },
        LoadMessagesFrom(sqn, post_id) {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
            this.loading = true
            highlight_post_id = post_id
            // highlight_post_sqn = sqn - 5
            SessionManager.PostsCall(sqn, "up").then(
                res => {
                    if (res.data.result && res.data.posts.length > 0) {
                        for (let i = 0; i < res.data.posts.length; i++) {
                            if (typeof res.data.posts[i].not_viewed_user_ids != 'undefined' &&
                                res.data.posts[i].not_viewed_user_ids.length > 0 &&
                                res.data.posts[i].not_viewed_user_ids.indexOf(this.loggedInUserDoc.user_id) > -1) {

                                hasUnreadMessages = true
                            }

                            SessionManager.AddPost(res.data.posts[i])
                        }
                    }
                    this.countNotViewed = res.data.countNotViewed
                }
            ).then(res => {
                this.CalculateSQN()
                this.mainSpinner = false
                document.getElementById("post_" + post_id).classList += " theme-highlight"
                setTimeout(function() {
                    document.querySelector("#chat_queue").scrollTop = document.getElementById("post_" + post_id).offsetTop - 3 * document.getElementById("post_" + post_id).offsetHeight
                }, 100)

                setTimeout(function() {
                    highlight_post_id = ''
                    Global.globalValue("close_search", true)
                }, 2000)
            })
        },
        getActiveDirectChannelOtherUserName() {
            let other_user_id = this.activeChannelDoc.user_ids.filter(currUserId => {
                return currUserId != SessionManager.getLoggedInUserId()
            })
            return SessionManager.getUser(other_user_id[0])
        },
        getOpacity() {
            if (this.loading) {
                return 0
            }
            return 1
        },
        reconnectNow() {
            Socket.reconnectAttempt();
        },
        displayMessageHeader(index, message) {
            return (index == 0 || this.showUser(message, this.messageQueue[index - 1])) && message.type == 'normal';
        }
    }
}
